import { useEffect, useState } from 'react';
import { getServerUrl } from '../utils/getServerUrl';
import { useQuerySession } from './useQuerySession';

type TrialHubData = {
  builderPublicApiKey: string;
  shouldDisplayTrialHub: boolean;
};

type Props = {
  isTrialing: boolean;
  isMobile: boolean;
  skip?: boolean;
};

export const useQueryTrialHub = ({
  isTrialing,
  isMobile,
  skip = false,
}: Props) => {
  const [isLoading, setIsLoading] = useState(true);
  const [trialHubData, setTrialHubData] = useState<TrialHubData>({
    builderPublicApiKey: '',
    shouldDisplayTrialHub: false,
  });
  const { data: sessionData } = useQuerySession();

  useEffect(() => {
    let apiSubscribed = true;

    async function getTrialHubData() {
      const serverUrl = getServerUrl();
      const sidebarUrl = `${serverUrl}/api/v2/navigation-data/trial-hub?is-trialing=${isTrialing}&is-mobile=${isMobile}`;

      const userId = sessionData?.customUserId?.toString() || '';

      try {
        setIsLoading(true);
        const response = await fetch(sidebarUrl, {
          credentials: 'omit',
          headers: {
            'x-customuser-id': userId,
          },
        });
        if (!response.ok) {
          throw new Error('Response was not OK');
        }

        if (apiSubscribed) {
          const json = await response.json();
          const { data } = json;
          setTrialHubData(data);
        }
      } catch (error) {
        // no-op
      } finally {
        if (apiSubscribed) {
          setIsLoading(false);
        }
      }
    }

    if (!skip && sessionData) getTrialHubData();

    return () => {
      apiSubscribed = false;
    };
  }, [sessionData, skip]);

  return { isLoading, data: trialHubData };
};
